import {
  CLIENT_DIGITAL_DOSSIER_SECTIONS_STATUS,
  VALIDATION_STATUSES,
} from '@bcba/types';

const mapDocument = (doc?: any) =>
  doc
    ? {
        uuid: doc.uuid || '',
        documentUuid: doc?.document?.uuid,
        keepOriginal: true,
        originalName: doc.document?.originalFileName || '',
        expirationDate: doc?.document?.expirationDate,
        identifier: doc?.document?.identifier,
      }
    : undefined;

export const mapDocumentationAndFormsSerializerToDTO = (response: any) => {
  const defaultPlaceholderForArrayField = [{}];
  const dto = {
    uuid: response.uuid,
    sisaFile: mapDocument(response.sisaDocument),
    statuteFile: mapDocument(response.statuteDocument),
    statuteChangeFiles:
      response.statuteChangeDocuments.length > 0
        ? response.statuteChangeDocuments.map(mapDocument)
        : defaultPlaceholderForArrayField,
    assemblyBoardMinutesFiles:
      response.assemblyBoardMinutesDocuments.length > 0
        ? response.assemblyBoardMinutesDocuments.map(mapDocument)
        : defaultPlaceholderForArrayField,
    powerOfAttorneyFiles:
      response.powerOfAttorneyDocuments.length > 0
        ? response.powerOfAttorneyDocuments.map(mapDocument)
        : defaultPlaceholderForArrayField,
    additionalDocumentFiles:
      response.additionalDocumentFiles.length > 0
        ? response.additionalDocumentFiles.map(mapDocument)
        : defaultPlaceholderForArrayField,
  };

  return dto;
};

export const mapDigitalDossierStatus = {
  [CLIENT_DIGITAL_DOSSIER_SECTIONS_STATUS.APPROVED]:
    VALIDATION_STATUSES.APPROVED,
  [CLIENT_DIGITAL_DOSSIER_SECTIONS_STATUS.PENDING_APPROVAL]:
    VALIDATION_STATUSES.PENDING_APPROVAL,
  [CLIENT_DIGITAL_DOSSIER_SECTIONS_STATUS.PENDING_DATA_UPLOAD]:
    VALIDATION_STATUSES.INCOMPLETE,
  [CLIENT_DIGITAL_DOSSIER_SECTIONS_STATUS.PENDING_REVIEW]:
    VALIDATION_STATUSES.PENDING_CHANGE_REQUEST,
  [VALIDATION_STATUSES.INCOMPLETE]: VALIDATION_STATUSES.INCOMPLETE,
};
